import {Grid} from '@material-ui/core';
import {SwitchCustom, TextBox, NumberFormatCustom} from '../../../Core/UI';
import React from 'react';
import {Parameter} from '../../../Core/mobx/ParameterStore/ParameterStore';
import {observer} from 'mobx-react-lite';
import {CategoryCard} from '../CategoryCard';
import {Approval} from '../../../Core/mobx/ParameterStore/Approval';
import {SelectInputElement} from '../../PreQualification/Components/SelectInputElement';
import {fieldOptions} from '../../../Core/mobx/ParameterStore/ApprovalXref';

type FinancialsProps = {
    valueChanged: (p?: Parameter, value?: any) => void;
    parameters: Approval;
    setCategory: (entry: string) => void;
    index: number;
};

const Financials = observer(({valueChanged, parameters, setCategory, index}: FinancialsProps) => {
    return (
        <CategoryCard title={'Financials (VUL Only)'} setCategory={setCategory} index={index}>
            <Grid item xs={12}>
                <div style={{fontSize: 20, color: '#5D6CC1', fontWeight: 'bold', marginTop: '1em'}}>
                    The Leaders Group
                </div>
            </Grid>
            <Grid item xs={4}>
                <SelectInputElement
                    param={{
                        label: 'Primary Source of Funding',
                        name: 'primaryFundingSource',
                        options: fieldOptions.primaryFundingSource.options,
                        ...parameters.primaryFundingSource,
                    }}
                    required={''}
                    valueChanged={valueChanged}
                />
            </Grid>

            <Grid item xs={4}>
                <TextBox
                    id="estimatedNetWorth"
                    label="Estimated Net Worth"
                    value={parameters.estimatedNetWorth?.value}
                    onChange={(value) => valueChanged(parameters.estimatedNetWorth, value)}
                    InputProps={{
                        inputComponent: NumberFormatCustom,
                    }}
                />
            </Grid>

            <Grid item xs={4}>
                <TextBox
                    id="investedAssets"
                    label="Investable/Liquid Assets"
                    value={parameters.investedAssets?.value}
                    onChange={(value) => valueChanged(parameters.investedAssets, value)}
                    InputProps={{
                        inputComponent: NumberFormatCustom,
                    }}
                />
            </Grid>

            <Grid item xs={4}>
                <SelectInputElement
                    param={{
                        label: 'Primary Investment Objective',
                        name: 'investmentObjective',
                        options: fieldOptions.investmentObjective.options,
                        ...parameters.investmentObjective,
                    }}
                    required={''}
                    valueChanged={valueChanged}
                />
            </Grid>

            <Grid item xs={4}>
                <SelectInputElement
                    param={{
                        label: 'Target Objective',
                        name: 'investmentTimeFrame',
                        options: fieldOptions.investmentTimeFrame.options,
                        ...parameters.investmentTimeFrame,
                    }}
                    required={''}
                    valueChanged={valueChanged}
                />
            </Grid>

            <Grid item xs={4}>
                <SelectInputElement
                    param={{
                        label: 'Risk Addressed With Investment',
                        name: 'investmentRisk',
                        options: fieldOptions.investmentRisk.options,
                        ...parameters.investmentRisk,
                    }}
                    required={''}
                    valueChanged={valueChanged}
                />
            </Grid>
            <Grid item xs={4}>
                <TextBox
                    id={'incomeIndividual'}
                    label={'Annual Income'}
                    value={parameters.incomeIndividual?.value}
                    onChange={(value) => valueChanged(parameters.incomeIndividual, value)}
                    InputProps={{
                        inputComponent: NumberFormatCustom,
                    }}
                />
            </Grid>
            <Grid item xs={4}>
                <SelectInputElement
                    param={{
                        label: 'Investment Knowledge',
                        name: 'investmentGeneralKnowledge',
                        options: fieldOptions.investmentGeneralKnowledge.options,
                        ...parameters.investmentGeneralKnowledge,
                    }}
                    required={''}
                    valueChanged={valueChanged}
                />
            </Grid>
            <Grid item xs={4}>
                <SelectInputElement
                    param={{
                        label: 'Effective tax rate',
                        name: 'effectiveTaxRate',
                        options: fieldOptions.effectiveTaxRate.options,
                        ...parameters.effectiveTaxRate,
                    }}
                    required={''}
                    valueChanged={valueChanged}
                />
            </Grid>
            <Grid item xs={4}>
                <SelectInputElement
                    param={{
                        label: 'Annual Expenses',
                        name: 'annualExpenses',
                        options: fieldOptions.annualExpenses.options,
                        ...parameters.annualExpenses,
                    }}
                    required={''}
                    valueChanged={valueChanged}
                />
            </Grid>

            <Grid item xs={4}>
                <SelectInputElement
                    param={{
                        label: 'Emergency Fund Amount',
                        name: 'emergencyFundAmount',
                        options: fieldOptions.emergencyFundAmount.options,
                        ...parameters.emergencyFundAmount,
                    }}
                    required={''}
                    valueChanged={valueChanged}
                />
            </Grid>
            <Grid item xs={12}>
                <div style={{fontSize: 20, color: '#5D6CC1', fontWeight: 'bold', marginTop: '1em'}}>Equitable</div>
            </Grid>
            <Grid item xs={4}>
                <TextBox
                    id="equitableCDS"
                    label="Value of Cash & Equivalents"
                    value={parameters.equitableCDS?.value}
                    onChange={(value) => valueChanged(parameters.equitableCDS, value)}
                    InputProps={{
                        inputComponent: NumberFormatCustom,
                    }}
                />
            </Grid>
            <Grid item xs={4}>
                <TextBox
                    id="equitableStocks"
                    label="Value of Stocks"
                    value={parameters.equitableStocks?.value}
                    onChange={(value) => valueChanged(parameters.equitableStocks, value)}
                    InputProps={{
                        inputComponent: NumberFormatCustom,
                    }}
                />
            </Grid>
            <Grid item xs={4}>
                <TextBox
                    id="equitableBonds"
                    label="Value of Bonds"
                    value={parameters.equitableBonds?.value}
                    onChange={(value) => valueChanged(parameters.equitableBonds, value)}
                    InputProps={{
                        inputComponent: NumberFormatCustom,
                    }}
                />
            </Grid>
            <Grid item xs={4}>
                <TextBox
                    id="equitableAnnuities"
                    label="Value of Annuities"
                    value={parameters.equitableAnnuities?.value}
                    onChange={(value) => valueChanged(parameters.equitableAnnuities, value)}
                    InputProps={{
                        inputComponent: NumberFormatCustom,
                    }}
                />
            </Grid>
            <Grid item xs={4}>
                <TextBox
                    id="equitableMutualFunds"
                    label="Value of Mutual Funds"
                    value={parameters.equitableMutualFunds?.value}
                    onChange={(value) => valueChanged(parameters.equitableMutualFunds, value)}
                    InputProps={{
                        inputComponent: NumberFormatCustom,
                    }}
                />
            </Grid>
            <Grid item xs={4}>
                <TextBox
                    id="equitableOtherProperties"
                    label="Value of Other Properties"
                    value={parameters.equitableOtherProperties?.value}
                    onChange={(value) => valueChanged(parameters.equitableOtherProperties, value)}
                    InputProps={{
                        inputComponent: NumberFormatCustom,
                    }}
                />
            </Grid>
            <Grid item xs={4}>
                <TextBox
                    id="equitableRetirementAccounts"
                    label="Value of Retirement Accounts"
                    value={parameters.equitableRetirementAccounts?.value}
                    onChange={(value) => valueChanged(parameters.equitableRetirementAccounts, value)}
                    InputProps={{
                        inputComponent: NumberFormatCustom,
                    }}
                />
            </Grid>
            <Grid item xs={4}>
                <TextBox
                    id="equitableOtherValue"
                    label="Value of Other"
                    value={parameters.equitableOtherValue?.value}
                    onChange={(value) => valueChanged(parameters.equitableOtherValue, value)}
                    InputProps={{
                        inputComponent: NumberFormatCustom,
                    }}
                />
            </Grid>
            <Grid item xs={4}>
                <TextBox
                    id="totalAssets"
                    label="Total Assets"
                    value={parameters.totalAssets?.value}
                    onChange={(value) => valueChanged(parameters.totalAssets, value)}
                    InputProps={{
                        inputComponent: NumberFormatCustom,
                    }}
                />
            </Grid>

            <Grid item xs={4}>
                <TextBox
                    id="equitableInvenstmentExpWithCDs"
                    label="Investment Exp with CD's"
                    value={parameters.equitableInvenstmentExpWithCDs?.value}
                    onChange={(value) => valueChanged(parameters.equitableInvenstmentExpWithCDs, value)}
                    type="number"
                />
            </Grid>
            <Grid item xs={4}>
                <TextBox
                    id="equitableInvenstmentExpWithStocks"
                    label="Investment Exp with Stocks"
                    value={parameters.equitableInvenstmentExpWithStocks?.value}
                    onChange={(value) => valueChanged(parameters.equitableInvenstmentExpWithStocks, value)}
                    type="number"
                />
            </Grid>
            <Grid item xs={4}>
                <TextBox
                    id="equitableInvenstmentExpWithBonds"
                    label="Investment Exp with Bonds"
                    value={parameters.equitableInvenstmentExpWithBonds?.value}
                    onChange={(value) => valueChanged(parameters.equitableInvenstmentExpWithBonds, value)}
                    type="number"
                />
            </Grid>
            <Grid item xs={4}>
                <TextBox
                    id="equitableInvenstmentExpWithAnnuities"
                    label="Investment Exp with Annuities"
                    value={parameters.equitableInvenstmentExpWithAnnuities?.value}
                    onChange={(value) => valueChanged(parameters.equitableInvenstmentExpWithAnnuities, value)}
                    type="number"
                />
            </Grid>
            <Grid item xs={4}>
                <TextBox
                    id="equitableInvenstmentExpWithMutualFunds"
                    label="Investment Exp with Mutual Funds"
                    value={parameters.equitableInvenstmentExpWithMutualFunds?.value}
                    onChange={(value) => valueChanged(parameters.equitableInvenstmentExpWithMutualFunds, value)}
                    type="number"
                />
            </Grid>

            <Grid item xs={4}>
                <SelectInputElement
                    param={{
                        label: 'Purpose of Recommendation',
                        name: 'equitableInvestmentPurposeRecommendation',
                        options: fieldOptions.equitableInvestmentPurposeRecommendation.options,
                        ...parameters.equitableInvestmentPurposeRecommendation,
                    }}
                    required={''}
                    valueChanged={valueChanged}
                />
            </Grid>
            <Grid item xs={4}>
                <SelectInputElement
                    param={{
                        label: 'Primary Risk',
                        name: 'equitableInvestmentRisk',
                        options: fieldOptions.equitableInvestmentRisk.options,
                        ...parameters.equitableInvestmentRisk,
                    }}
                    required={''}
                    valueChanged={valueChanged}
                />
            </Grid>
            <Grid item xs={4}>
                <SelectInputElement
                    param={{
                        label: 'Effective Tax Rate',
                        name: 'equitableEffectiveTaxRate',
                        options: fieldOptions.equitableEffectiveTaxRate.options,
                        ...parameters.equitableEffectiveTaxRate,
                    }}
                    required={''}
                    valueChanged={valueChanged}
                />
            </Grid>
            <Grid item xs={4}>
                <TextBox
                    id="equitableConcerns"
                    label="Concerns with Investment"
                    value={parameters.equitableConcerns?.value}
                    onChange={(value) => valueChanged(parameters.equitableConcerns, value)}
                />
            </Grid>
            <Grid item xs={4}>
                <SwitchCustom
                    param={{
                        name: 'isPrincipalProtectionOrIncomeGuarantees',
                        label: 'Protections or Guarantees',
                        ...parameters.isPrincipalProtectionOrIncomeGuarantees,
                    }}
                    required={''}
                    valueChanged={valueChanged}
                />
            </Grid>
        </CategoryCard>
    );
});

export default Financials;
